import styled from 'styled-components';
import { getColor, getColorShade } from '../../../src/styled/utils';
export const Background = styled.rect.attrs({ width: '416', height: '219', x: '0', y: '0' }) `
  fill: ${getColor('background')};
`;
export const WhiteRect = styled.rect.attrs({ rx: '2' }) `
  fill: ${getColor('surface')};
`;
export const MainRect = styled.rect `
  fill: ${getColorShade('onSurface', 'highEmphasis')};
  fill-opacity: 0.14;
`;
export const MainStrokeRect = styled.rect.attrs({ rx: '1.85' }) `
  stroke: ${getColorShade('onSurface', 'highEmphasis')};
  stroke-width: 0.3;
  stroke-opacity: 0.14;
`;
export const MainCircle = styled.circle `
  fill: ${getColorShade('onSurface', 'highEmphasis')};
  fill-opacity: 0.14;
  stroke: ${getColor('background')};
  stroke-width: 0.3;
`;
export const MainFillStrokePath = styled.path `
  fill: ${getColorShade('onSurface', 'highEmphasis')};
  fill-opacity: 0.14;
  stroke: ${getColor('background')};
  stroke-width: 0.3;
`;
export const WhiteCircle = styled.circle `
  fill: ${getColor('background')};
`;
export const MainStrokePath = styled.path `
  stroke: ${getColorShade('onSurface', 'highEmphasis')};
  stroke-opacity: 0.14;
  stroke-width: 0.3;
`;
